import { pick, values } from "lodash-es";
import { useMemo } from "react";

export const useDisabledDependency = ({
  disabledDependencies,
  watchAllFields,
}: {
  disabledDependencies?: string[];
  watchAllFields: { [name: string]: boolean };
}) => {
  const isDisabled = useMemo(
    () => values(pick(watchAllFields, disabledDependencies || [])).includes(true),
    [disabledDependencies, watchAllFields]
  );

  return { isDisabled };
};
